import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=1b1ef6ec"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=1b1ef6ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports